import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-243">
      <MetaPixel data-id="element-244" />
      <Hero data-id="element-245" />
      <ProblemSection data-id="element-246" />
      <SolutionSection data-id="element-247" />
      <IncludesSection data-id="element-248" />
      <PricingCTA data-id="element-249" />
      <Footer data-id="element-250" />
    </div>;
}